import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=4e2fa499&scoped=true&"
import script from "./collect.vue?vue&type=script&lang=js&"
export * from "./collect.vue?vue&type=script&lang=js&"
import style0 from "./collect.vue?vue&type=style&index=0&id=4e2fa499&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fa499",
  null
  
)

export default component.exports